module.exports = __webpack_public_path__ + "static/media/human.4fe19739.png";